<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  export default {
    name: 'TopicSuggestionOverlay',
    props: {
      topic: Object,
    },
    computed: {
      opened: {
        set() {
          this.$emit('onCloseOverlay')
        },
        get() {
          return this.topic
        },
      },
    },
    methods: {
      acceptTopic() {
        this.$emit('accept', this.topic.id)
        this.$emit('onCloseOverlay')
      },
      declineTopic() {
        this.$emit('decline', this.topic.id)
        this.$emit('onCloseOverlay')
      },
    },
  }
</script>
